import { getProductFormField } from '../utils';
import Component from './ProductFormAmountInput';
import { injectIntl } from 'react-intl';

export default getProductFormField(injectIntl(Component));
